import React from "react";

function ActiveSecondIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="8"
      fill="none"
      viewBox="0 0 8 8"
    >
      <circle cx="4" cy="4" r="4" fill="url(#paint0_linear_588_2286)"></circle>
      <defs>
        <linearGradient
          id="paint0_linear_588_2286"
          x1="6.963"
          x2="4"
          y1="3.111"
          y2="8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#07F490"></stop>
          <stop offset="1" stopColor="#30D1E0"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default ActiveSecondIcon;